import { useMutation } from '@percent/partner-dashboard/common/hooks/useMutation/useMutation'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type Err = Record<'code' | 'message' | 'title', string>

export type UseCreateCampaignGroupProps = Readonly<{
  onCreated: () => void
  onError: (error: Err) => void
}>

export type UseCreateCampaignGroupReturn = Readonly<{
  isLoading: boolean
  createGroup: (name: string) => void
}>

const defaultError: Err = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useCreateCampaignGroup = ({
  onCreated,
  onError
}: UseCreateCampaignGroupProps): UseCreateCampaignGroupReturn => {
  const { workplaceGivingService } = useServices()

  const [{ isLoading }, { apiFunc: createCampaignGroup }] = useMutation(
    workplaceGivingService.createCampaignGroup,
    () => {
      onCreated()
    },
    error => {
      if (error) {
        onError(error.response?.data?.error ?? defaultError)
      }
    }
  )

  return {
    isLoading,
    createGroup: (name: string) => {
      createCampaignGroup({ name })
    }
  }
}
